import { FluzPayOptions } from '@fluzfluzny/common-sdk/interfaces';

type FluzPayBalanceFlags = {
  usePrepayment: boolean;
  useRewards: boolean;
};

export function mapFluzPayOptions({ usePrepayment, useRewards }: FluzPayBalanceFlags): FluzPayOptions {
  return {
    use_prepayment_balance: usePrepayment,
    use_rewards_balance: useRewards,
  };
}
